<template>
  <div :class="['ls-layout', 'ls-layout-' + type]">
    <div class="layout-header">
      <LsHeader></LsHeader>
    </div>
    <div class="layout-content">
      <slot></slot>
    </div>
    <div class="layout-footer">
      <LsFooter></LsFooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "LsLayout",
  props: {
    type: String,
    default: "default"
  }
}
</script>
<style>
.ls-layout {
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  background: rgb(246, 246, 247);
  /* overflow: hidden; */
}

.layout-header {
  background: #ffffff;
}

.layout-header .ls-button {
  background-color: rgba(252, 195, 7, 0.1);
  border-color: transparent;
  color: #FCAE07;
  margin-left: 20px;
}

.layout-header .navbar-toggle span {
  background: #666 !important;
}

.layout-content {
  /* flex: 1; */
  margin: 12px 0;
  overflow: hidden;
  /* min-height: 845px; */
}

.layout-footer {
  height: 85px;
}

.layout-footer .footer {
  /* position: fixed;
  bottom: 0;
  left: 0;
  width: 100%; */
}


.ls-layout-vertical {
  display: block;
  overflow-y: auto;
}

.ls-layout-vertical .footer {
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/LsLayout.vue